// extracted by mini-css-extract-plugin
export var divider = "_gy-7";
export var itemsToggle = "_gy-8";
export var mergeModal = "_gy-1";
export var optionCard = "_gy-4";
export var radioGroup = "_gy-6";
export var radioOption = "_gy-0";
export var selected = "_gy-5";
export var shipmentOptions = "_gy-2";
export var tableOptions = "_gy-3";